import { render } from "./LoaderWithFallback.vue?vue&type=template&id=afffae8e&scoped=true"
import script from "./LoaderWithFallback.vue?vue&type=script&lang=js"
export * from "./LoaderWithFallback.vue?vue&type=script&lang=js"

import "./LoaderWithFallback.vue?vue&type=style&index=0&id=afffae8e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afffae8e"]])

export default __exports__